import { PaymentStatus } from '../types/transaction';

export function derivePaymentStatus(
  invoiceOrBill:
    | {
        status?: string | null;
        amount?: { amount: number } | null;
        openAmount?: { amount: number } | null;
      }
    | null
    | undefined,
): PaymentStatus {
  if (!invoiceOrBill) return 'Unpaid';

  if (invoiceOrBill.status === 'Voided') return 'Voided';

  const amount = invoiceOrBill.amount?.amount;
  const openAmount = invoiceOrBill.openAmount?.amount;

  if (amount == null || openAmount == null) return 'Unpaid';

  if (openAmount <= 0) return 'Paid';
  if (openAmount > 0 && openAmount < amount) return 'Partial';

  return 'Unpaid';
}
